import { type FC, useState } from "react";
import { useTranslation } from "react-i18next";
import { useFilter } from "@/partner/shared/components/Filter";
import { BarChartCard } from "@/partner/shared/components/BarChartCard";
import type { CalendarIntervalValue } from "@/partner/shared/components/AnalyticsCalendarInterval";
import { formatCurrency } from "@/partner/features/products";
import { useAnalyticsRevenueByDateQuery } from "@/partner/entities/analytics";
import { DownloadReportButton } from "@/partner/features/reports";
import {
  AnalyticsWidgetType,
  ReportTypeType,
} from "@/types/graphql/partner.generated";

export const AnalyticsRevenueByDateChart: FC = () => {
  const { t } = useTranslation();
  const { filter } = useFilter();
  const [calendarInterval, setCalendarInterval] =
    useState<CalendarIntervalValue>();

  const { data, loading, error } = useAnalyticsRevenueByDateQuery({
    fetchPolicy: "no-cache",
    variables: {
      filter: filter as never,
      calendarInterval: calendarInterval as never,
    },
  });

  return (
    <BarChartCard
      title={t("analytics.sales.chartRevenueByDate")}
      chart={data?.analyticsSales.revenueByDate}
      loading={loading}
      error={error}
      dateFrom={filter.dateFrom}
      dateTo={filter.dateTo}
      onChangeCalendarInterval={setCalendarInterval}
      renderTrickY={(value) =>
        // Валюта отчётов организации, а не displayCurrency первой серии:
        // серий может не быть вовсе (пустой период), и подпись оси молча
        // уезжала бы в доллары на организации с MDL или EUR.
        formatCurrency(value, data?.analyticsSales.currency ?? "USD")
      }
      downloadButton={
        <DownloadReportButton
          variant="card"
          type={ReportTypeType.AnalyticsWidgetType}
          widget={AnalyticsWidgetType.RevenueByDateType}
          filter={filter}
          variables={{ calendarInterval }}
        />
      }
    />
  );
};
